import React from "react"
import { taskShape } from "utils/propTypeShapes"
import { TASK_FORM_DELETED_QUESTIONS_NOTE, taskAnswerValues } from "utils/taskHelpers"
import { AnsweredFormOverview } from "shared/form"

const TaskDeletedQuestionAnswers = ({ task }) => {
  const { answers, subform } = task

  if (!subform) return null

  const { deletedQuestions = [] } = subform
  const answerValues = taskAnswerValues(answers)

  return (
    <AnsweredFormOverview
      answers={answerValues}
      deletedQuestionsNote={TASK_FORM_DELETED_QUESTIONS_NOTE}
      deletedQuestions={deletedQuestions}
      sections={[]}
    />
  )
}

TaskDeletedQuestionAnswers.propTypes = {
  task: taskShape.isRequired,
}

export default TaskDeletedQuestionAnswers
